import { action, createRequestTypes } from '@/utils/actions.utils'
import { collectionsService } from '@/services'

export const FETCH_COLLECTIONS = createRequestTypes('FETCH_COLLECTIONS')
const fetchCollections = ({ catalogId, lang, withImages = true, rolId = "" }) => {
	return async (dispatch, getState) => {
		try {
			await dispatch(request())

			const isAuthenticated = getState().auth.logged
			const userEmail = getState().auth.account?.email
			const res = await collectionsService.fetchCollections({ catalogId, lang, withImages, rolId, isAuthenticated, userEmail })

			return dispatch(success(res.data))

		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_COLLECTIONS.REQUEST)
	}
	function success(payload) {
		return action(FETCH_COLLECTIONS.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_COLLECTIONS.FAILURE, null, err)
	}
}

export const GET_COLLECTION = createRequestTypes('GET_COLLECTION')
const getCollection = ({ catalogId, lang, subFamilyId, withImages = true }) => {
	return async (dispatch, getState) => {
		try {
			await dispatch(request())

			const isAuthenticated = getState().auth.logged
			const userEmail = getState().auth.account?.email
			const res = await collectionsService.fetchCollections({ catalogId, lang, subFamilyId, withImages, isAuthenticated, userEmail })

			// A subFamilyId may appear in multiple entries (one per sublevel) and the backend
			// can order them differently depending on `lang` (it sorts by translated fields).
			// Only one entry has `subFamily.decisionTree` configured — pick it over the raw [0]
			// to keep the configurator working regardless of language.
			const preferred = res.data?.find(item => item?.subFamily?.decisionTree) || res.data?.[0]

			return dispatch(success(preferred))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(GET_COLLECTION.REQUEST)
	}
	function success(payload) {
		return action(GET_COLLECTION.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_COLLECTION.FAILURE, null, err)
	}
}

export const SELECT_COLLECTION = 'SELECT_COLLECTION'
const selectCollection = (collection) => {
	return action(SELECT_COLLECTION, collection)
}

export const UNSELECT_COLLECTION = 'UNSELECT_COLLECTION'
const unselectCollection = () => {
	return action(UNSELECT_COLLECTION)
}

export default {
	fetchCollections,
	getCollection,
	selectCollection,
	unselectCollection
}
